import Adam_Biciste from './avatar_Adam.svg';
import Andrea_Sliacka from './avatar_Andy.svg';
import Zaneta_Mikusova from './avatar_Zanet.svg';
import Tomas_Rokos from './avatar_Tomas.svg';
import Lukas_Rykr from './avatar_Lukas.svg';
import Lenka_Hanakova from './avatar_Lenka.svg';
import Simona_Kijonkova from './avatar_Simona.svg';
import Jaromir_Kijonka from './avatar_Jarda.svg';
import Tomas_Pesek from './avatar_Tomy.svg';

export default {
  Adam_Biciste,
  Andrea_Sliacka,
  Zaneta_Mikusova,
  Tomas_Rokos,
  Lukas_Rykr,
  Lenka_Hanakova,
  Simona_Kijonkova,
  Jaromir_Kijonka,
  Tomas_Pesek,
};
